import { render } from "./GlobalLoader.vue?vue&type=template&id=76dc0abb&scoped=true"
import script from "./GlobalLoader.vue?vue&type=script&lang=js"
export * from "./GlobalLoader.vue?vue&type=script&lang=js"

import "./GlobalLoader.vue?vue&type=style&index=0&id=76dc0abb&lang=css"
import "./GlobalLoader.vue?vue&type=style&index=1&id=76dc0abb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76dc0abb"]])

export default __exports__